import styled from 'styled-components'

import { Skeleton, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.main`
  position: relative;
  z-index: 0;
  display: grid;
  grid-template-columns: 1fr;
`

export const PrimaryContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  ${fromMd} {
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: ${o => o.theme.spacing(6)};
  }
`

export const GalleryImageCarousel = styled(Skeleton).attrs({ animated: true })`
  height: 400px;
`

export const Accordion = styled.div`
  background: ${o => o.theme.color.deprecated.stoneLighter};
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
`

export const AccordionSection = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  padding: 24px;
`
